import Poll from '@/models/polls/Poll'
import _ from 'lodash'

import router from '@/routes'
import store from '@/store'

import {ActiveTableConfig} from '@/components/Ui/ActiveTable/BZCore/ActiveTable'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'
import {TableOptions} from '@/components/Ui/ActiveForm/BZCore/Table/Table'

import recipientsComponent from '@/components/Newsletters/TableCols/recipients.vue'
import statusComponent from '@/components/polls/list/cols/status.vue'

// @ts-ignore
import messages from '@/lang/index';

const ActiveTableConfig: ActiveTableConfig<Poll> = {
  documentsName: messages.labels.polls1,
  onRowClick ({row}) {
    router.push({name: 'pollsPage', params: {id: row.getId()}})
  },
  async find (search, filters, sortKeys, limit, offset, scope) {
    console.log('LOG: find -> scope', scope)
    const params = {
      limit,
      offset,
      query: {
        // ...filters,
        ...scope
      }
      // sort
    }
    const result = await store.dispatch('poll/find', params)
    return {
      count: result.count,
      list: result.polls
    }
  },
  filtersAndActions: {
    pageName: messages.labels.search_and_filters,
    searchFormButtonText: messages.labels.search_form_button_text,
    hideFilters: true,
    searchForm: {
      inputs: {
      },
      steps: []
    },
    filters: {}
  },
  actions: [
    {
      name: messages.labels.delete,
      icon: 'trash',
      async handler (item) {
        await store.dispatch('poll/delete', item.getId())
        return true
      }
    }
  ],
  defaultShownColumns: ['title', 'id', 'recipients', 'rcpt_num', 'ans_total', 'send_at_date', 'status'],
  table: {
    cols: {
      title: {label: messages.polls.cols.title},
      id: {label: messages.polls.cols.id},
      recipients: {label: messages.polls.cols.recipients, component: recipientsComponent, styles: {'max-width': '150px'}},
      rcpt_num: {label: messages.polls.cols.rcpt_num, styles: {'max-width': '90px'}},
      ans_total: {label: messages.polls.cols.ans_total, styles: {'max-width': '90px'}},
      send_at_date: {label: messages.polls.cols.send_at_date},
      // finish_at_date: {label: messages.polls.cols.finish_at_date},
      status: {label: messages.labels.cols.status, component: statusComponent}
    }
  } as TableOptions
}
export default ActiveTableConfig